import { styled } from "@mui/material/styles";

import { Box } from "ui/box/box";
import { STATUS_INDICATOR_COLOR, STATUS_SIZE } from "ui/status/status.constants";
import { type StatusSize, type StatusType } from "ui/status/status.types";

const isStatusProp = (prop: PropertyKey) => prop === "statusSize" || prop === "statusType";

export const StatusRoot = styled(Box, {
  shouldForwardProp: (prop) => !isStatusProp(prop),
})<{ statusSize: StatusSize }>(({ theme, statusSize }) => ({
  display: "inline-flex",
  alignItems: "center",
  whiteSpace: "nowrap",
  padding: STATUS_SIZE[statusSize].padding,
  gap: STATUS_SIZE[statusSize].gap,
  color: theme.palette.text.primary,
}));

export const StatusDot = styled(Box, {
  shouldForwardProp: (prop) => !isStatusProp(prop),
})<{ statusSize: StatusSize; statusType: StatusType }>(({ theme, statusSize, statusType }) => ({
  flexShrink: 0,
  borderRadius: "50%",
  width: STATUS_SIZE[statusSize].indicator,
  height: STATUS_SIZE[statusSize].indicator,
  backgroundColor: STATUS_INDICATOR_COLOR[statusType](theme),
}));
